/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

import { track } from '../../utils/track';
import { IS_SINGLE_TENENT_MODE } from '../../constants';

export default function BankIDSignInButton({ width }) {
  const { t, i18n } = useTranslation();

  if (IS_SINGLE_TENENT_MODE) {
    return null;
  }

  return (
    <a
      href={`/api/login/signicat-login?lang=${i18n.language}`}
      onClick={() => track('sign_in_with_bankid')}
    >
      <Button
        variant="contained"
        color="white"
        startIcon={
          <img
            height={41 - 12}
            src="/BankID_logo_black.svg"
            alt="BankID Login"
          />
        }
        css={css`
          border: 1px solid #8c8c8c;
          box-shadow: none;
          color: #5e5e5e;
          font-weight: 600;
          width: ${width};
        `}
        sx={{ width: width }}
      >
        {t('Fortsätt med BankID')}
      </Button>
    </a>
  );
}
